import { _ } from 'utils'
import { createEventRoute } from 'utils/routes'
import CreateMeeting from './components/CreateMeeting'
import UpdateMeeting from './components/UpdateMeeting'
import MeetingSpace from './MeetingSpace'

export default {
    meeting: createEventRoute<{ meetingSlug: string }>({
        title: _('meeting.update_meeting_space_header', {}, false),
        breadcrumb: _('meeting.update_meeting_space_header', {}, false),
        hasSpaceBreadcrumb: true,
        path: '/meeting/:meetingSlug',
        component: MeetingSpace,
        exact: true,
        context: 'meeting-space'
    }),
    createMeeting: createEventRoute<{ meetingSlug: string }>({
        title: _('meeting.create_meeting_header', {}, false),
        breadcrumb: _('meeting.create_meeting_header', {}, false),
        hasSpaceBreadcrumb: true,
        path: '/meeting/:meetingSlug/create',
        component: CreateMeeting,
        exact: true,
        hasBackButton: true,
        context: 'meeting-create'
    }),
    updateMeeting: createEventRoute<{ meetingSlug: string, meetingId: number }>({
        title: _('meeting.update_meeting_header', {}, false),
        breadcrumb: _('meeting.update_meeting_header', {}, false),
        hasSpaceBreadcrumb: true,
        path: '/meeting/:meetingSlug/:meetingId',
        component: UpdateMeeting,
        exact: true,
        hasBackButton: true,
        context: 'meeting-update'
    }),
}
